import { render, staticRenderFns } from "./SetupCourse.html?vue&type=template&id=8de5b44c&scoped=true&external"
import script from "./SetupCourse.vue?vue&type=script&lang=js"
export * from "./SetupCourse.vue?vue&type=script&lang=js"
import style0 from "./SetupCourse.scss?vue&type=style&index=0&id=8de5b44c&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8de5b44c",
  null
  
)

export default component.exports